import { Button, InputAdornment, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import request from '../../../../Helpers/API';
import Swal from 'sweetalert2';
import SimCardIcon from '@mui/icons-material/SimCard';
import { useHistory } from "react-router-dom";
import { RegularExpressions } from '../../../../Helpers/RegularExpression';

const UsuarioImei = ({ idusuario, setMostrarImei}) => {
    const history = useHistory();
    const [usuario, setUsuario] = useState({
        idusuario: idusuario,
        imei: '',
        estatus: 1,
    })

    const onCerrar = () => {
        setMostrarImei(false);
    };

    const isValidIMEI = (input) => {
        return RegularExpressions.TextOnlyNumber.test(input);
    }

    const handleIMEIChange = (e) => {
        const inputValue = e.target.value;

        if (isValidIMEI(inputValue) || inputValue === '') {
            setUsuario(usuario => ({ ...usuario, imei: inputValue }));
        }
    }

    useEffect(() => {
        // setLoader({ ...loader, mostrar: true });
        request
            .get(`UsuarioImei/BuscarID?idusuario=${Number(idusuario)}`)
            .then((result) => {
                // setLoader({ ...loader, mostrar: false });
                setUsuario({
                    ...usuario,
                    idusuario: result.idusuario,
                    imei: result.imei,
                    estatus: result.estatus,
                });
            })
            .catch((error) => {
                // Verificar si el error es debido a un JSON vacío
                if (error.message !== "Unexpected end of JSON input") {
                    // setLoader({ ...loader, mostrar: false });
                    Swal.fire("BUSCAR IMEI", JSON.stringify(error), "error");
                }
            });
    }, []);




    const onGuardar = () => {
        //   setLoader({ ...loader, mostrar: true });
        if (usuario.imei.length !== 15) {
            Swal.fire({
                title: "AGREGAR IMEI",
                text: "EL IMEI DEBE CONTENER 15 DIGITOS",
                icon: "error",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }
        else {
            const post = {
                idusuario: idusuario,
                imei: usuario.imei,
                estatus: usuario.estatus,
            };
            request
                .post(`UsuarioImei`, post)
                .then(async () => {
                    //   setLoader({ ...loader, mostrar: false });

                    await Swal.fire({
                        title: "AGREGAR IMEI",
                        text: "Registro guardado con éxito",
                        icon: "success",
                        customClass: {
                            container: "mi-superpoop",
                        },
                    });
                    history.push("/Permisos/Main")
                })
                .catch((error) => {
                    // setLoader({ ...loader, mostrar: false });
                    Swal.fire("PERMISOS", JSON.stringify(error), "error");
                });
        }
    };
    return (
        <div className='permisos-usuarios-imei-screen-container'>
            <div >
                <div className="credito-agregar-modal-title">
                    {/* <Agriculture
              color="primary"
              style={{ textAlign: "center", fontSize: 50 }}
            /> */}
                    <div className="filtro-soy-el-titulo-header">
                        <h3>{usuario.imei === 0 || usuario.imei === null || usuario.imei === "" ? "EDITAR IMEI" : "AGREGAR IMEI"} </h3>
                    </div>
                </div>
                <div className="modal-tasa-intereses-filtro-soy-el-titulo-line">
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-bl"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-circle"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-br"></div>
                </div>
            </div>
            <div className='permisos-usuarios-agregar-imei-input'>
                <TextField
                    label="IMEI"
                    fullWidth
                    margin="normal"
                    type='text'
                    value={usuario.imei}
                    // onChange={(e) => setUsuario(usuario => ({ ...usuario, imei: e.target.value }))}
                    onChange={handleIMEIChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SimCardIcon />
                            </InputAdornment>
                        ),
                    }}
                    inputProps={{
                        maxLength: 15,
                      }}
                />
            </div>

            <div className="permisos-usuarios-agregar-imei-button-container ">
                <Button variant="contained" color="error"
                    onClick={() => onCerrar()}
                >
                    Cerrar
                </Button>
                <Button variant="contained"
                    onClick={() => onGuardar()}
                >
                    {usuario.imei && usuario.imei.length > 0 ? 'EDITAR' : 'GUARDAR'}
                </Button>
            </div>

        </div>
    )
}

export default UsuarioImei
